// Teksten van de ouder-webapp voor sprint 2 en 3 (docs/DESIGN.md §8.W1–W12): Vandaag, agenda,
// afspraak-editor, ritten, taken, beloningen, goedkeuren, leden, apparaten, instellingen en de
// wizard. Apart van `nl` (Messages) zodat de kiosk-bundle deze teksten nooit meeneemt: de kiosk
// importeert alleen `nl`/`en`, de webapp daarnaast `appMessagesFor()`.
//
// Toon: je-vorm, korte zinnen, werkwoorden op knoppen, geen jargon (DESIGN.md §2.9).
import { appSettingsHubNl } from './settingsHub.nl.js';
import { appOmgevingNl } from './omgevingApp.nl.js';
import { appRecurrenceNl } from './recurrenceApp.nl.js';
import { appDomeinNl } from './domeinApp.nl.js';
import { appMemorizeNl } from './memorizeApp.nl.js';
import { appSamenNl } from './samenApp.nl.js';
import { appCareNl } from './careApp.nl.js';
import { appCultureNl } from './cultureApp.nl.js';
import { appProfileNl } from './profileApp.nl.js';
import { appRemindersNl } from './remindersApp.nl.js';
import { appTodoNl } from './todoApp.nl.js';
import { appMissedNl } from './missedApp.nl.js';
import { appBillingNl } from './billingApp.nl.js';
import { appTimePickerNl } from './timePicker.nl.js';
import { appRidesNl } from './ridesApp.nl.js';
import { appModulesNl } from './modulesApp.nl.js';
import { appHouseholdsNl } from './householdsApp.nl.js';
import { appPushNl } from './pushApp.nl.js';
import { appActivitiesNl, appChecklistNl } from './golf2App.nl.js';
import { appGrowthNl, appSchoolNl } from './groeiSchoolApp.nl.js';
import { appLanguagesNl } from './languagesApp.nl.js';
import { appReadAloudNl } from './readAloudApp.nl.js';
import { appFeedsNl, appPlacesNl, appTravelNl } from './kaartApp.nl.js';
import { appBeheerNl } from './beheerApp.nl.js';
import { appWerklijstNl } from './werklijstApp.nl.js';
import { appVirtualDeviceNl } from './virtualDevice.nl.js';
import { appBoardViewNl } from './boardViewApp.nl.js';
import { appDailyNl } from './dailyApp.nl.js';
import { appThemesNl } from './themesApp.nl.js';
import { appBoardConfigNl } from './boardConfigApp.nl.js';
import { appAgendaViewsNl, appHomeNl, appWeatherDetailNl } from './homeApp.nl.js';
import { appGolf6Nl } from './golf6App.nl.js';
import { appPrivacyRightsNl } from './privacyRights.nl.js';
import { appChildConsentNl, appPrivacyStatementNl } from './golf5App.nl.js';
export const appNl = {
    // Golf 7 (0048): Soera's leren (memorizeApp.nl.ts).
    // Nieuwe adressen (amumin.app, board.amumin.app): bedrijfsgegevens en meldingen (domeinApp.nl.ts).
    domein: appDomeinNl,
    memorize: appMemorizeNl,
    // Golf 8 (0049): Samen wonen (samenApp.nl.ts).
    samen: appSamenNl,
    // Golf 8 (0050): dagelijkse check-in en familiekring (careApp.nl.ts).
    care: appCareNl,
    // 0021: herinneringen bij afspraken (remindersApp.nl.ts).
    reminders: appRemindersNl,
    // 0058: to-do's zonder datum of tijd (todoApp.nl.ts).
    todo: appTodoNl,
    // feat/gemiste-taken: gemiste taken alsnog afvinken (missedApp.nl.ts).
    missed: appMissedNl,
    // 0065: aanmelden, abonnement en de banner na de proefmaand (billingApp.nl.ts).
    billing: appBillingNl,
    // 0023: "Wat past bij ons gezin" (profileApp.nl.ts).
    profile: appProfileNl,
    // 0024: gefilterde lijsten, eetmeldingen, "Wie eet mee?" (cultureApp.nl.ts).
    culture: appCultureNl,
    // Tijdkiezer (packages/ui TimeField; timePicker.nl.ts).
    timePicker: appTimePickerNl,
    // 0022: brengen en halen per dag (ridesApp.nl.ts).
    ridesPerDay: appRidesNl,
    // 0029: modules per gezin (modulesApp.nl.ts).
    modules: appModulesNl,
    // Golf 6b (0043): soorten huishouden en het beurtrooster (householdsApp.nl.ts).
    households: appHouseholdsNl,
    // 0038: meldingen op je telefoon (pushApp.nl.ts).
    push: appPushNl,
    // 0031 (golf 2): checklist bij een herinnering, vaste activiteiten met pauzes (golf2App.nl.ts).
    checklist: appChecklistNl,
    activities: appActivitiesNl,
    // 0032 (golf 3): Groei (module Gezondheid) en School (groeiSchoolApp.nl.ts).
    growth: appGrowthNl,
    school: appSchoolNl,
    // Golf 3 (0033_talen): taalvraag, Instellingen · Taal, eigen taal per lid en tablet.
    languages: appLanguagesNl,
    // Voorleesknop op het bord per gezinslid (readAloudApp.nl.ts).
    readAloud: appReadAloudNl,
    // 0034 (golf 3): plaatsen zoeken, reistijd, agenda koppelen (kaartApp.nl.ts).
    places: appPlacesNl,
    travel: appTravelNl,
    feeds: appFeedsNl,
    // Werklijst van de platformbeheerder (werklijstApp.nl.ts).
    werklijst: appWerklijstNl,
    // AMUMIN Beheer, meekijken, gepauzeerd bord, uitnodiging eigenaar (beheerApp.nl.ts).
    beheer: appBeheerNl,
    // 0028: Virtuele iPad (virtualDevice.nl.ts).
    virtualDevice: appVirtualDeviceNl,
    // Menu Board: het echte bord live bekijken (boardViewApp.nl.ts).
    boardView: appBoardViewNl,
    // WP4: Sterren in Taken, Ritten in Agenda, Prikbord, Kinderen, Recepten en Weekmenu (dailyApp.nl.ts).
    daily: appDailyNl,
    themes: appThemesNl,
    // Golf 6b: Vandaag als widgets, agendaweergaven en het weerdetail (homeApp.nl.ts).
    home: appHomeNl,
    // Scherm inrichten: widgets van het bord per tablet (boardConfigApp.nl.ts).
    boardConfig: appBoardConfigNl,
    agendaViews: appAgendaViewsNl,
    weatherDetail: appWeatherDetailNl,
    // Golf 6a: iPad koppelen (uitleg en QR-code), wachtwoordvenster, beginscherm, advies (golf6App.nl.ts).
    golf6: appGolf6Nl,
    // 0036: privacyrechten (privacyRights.nl.ts).
    privacyRights: appPrivacyRightsNl,
    // Instellingen als overzicht (settingsHub.nl.ts).
    settingsHub: appSettingsHubNl,
    // Omgevingen, eigen thema, agendaverbindingen (omgevingApp.nl.ts).
    omgeving: appOmgevingNl,
    // Herhaling in gewone taal (recurrenceApp.nl.ts; packages/domain summaryLang.ts).
    recurrenceText: appRecurrenceNl,
    // Golf 5 (0044): toestemming voor een kindlogin of foto; de privacyverklaring (golf5App.nl.ts).
    childConsent: appChildConsentNl,
    privacyStatement: appPrivacyStatementNl,
    nav: {
        // 0060: module Notities.
        notes: 'Notities',
        // 0064: module Fotolijst.
        photos: 'Fotolijst',
        kompas: 'Gezond op gewicht',
        // 0069: module Geldzaken (privé).
        money: 'Geldzaken',
        // Oprichter 6 okt: eigen to-do's in Mijn omgeving.
        myTodos: "Mijn to-do's",
        today: 'Vandaag',
        board: 'Bord',
        agenda: 'Agenda',
        tasks: 'Taken',
        rewards: 'Beloningen',
        approvals: 'Goedkeuren',
        members: 'Gezin',
        devices: 'Tablets',
        settings: 'Instellingen',
        security: 'Beveiliging',
        household: 'Huishouden instellen',
        rides: 'Ritten',
        growth: 'Groei',
        school: 'School',
        more: 'Meer',
        // WP2 (compact-plan): de vijf vaste plekken en de samengevoegde pagina's onder Meer.
        pinboard: 'Prikbord',
        children: 'Kinderen',
        together: 'Samen',
        boardHub: 'Bord',
        boardView: 'Weergave',
        stars: 'Sterren',
        membersTab: 'Leden',
        circle: 'Kring',
        forYou: 'Voor jou',
        forYouWaiting: 'Goedkeuren: {n}',
        menu: 'Menu',
        logout: 'Uitloggen',
        /** Eigen blokje onderaan de navigatie, alleen voor de platformbeheerder. */
        admin: 'Beheer',
        werklijst: 'Werklijst',
        beheer: 'Klanten',
        main: 'Hoofdmenu',
        skip: 'Naar de inhoud',
    },
    common: {
        save: 'Opslaan',
        cancel: 'Annuleren',
        delete: 'Verwijderen',
        edit: 'Bewerken',
        add: 'Toevoegen',
        close: 'Sluiten',
        back: 'Terug',
        next: 'Volgende',
        later: 'Later doen',
        undo: 'Ongedaan maken',
        retry: 'Opnieuw proberen',
        /** WP1: de (i)-knop met uitleg (PageHeader, InfoButton) en "+n meer" onder een kaart. */
        info: 'Uitleg',
        moreCount: '+{n} meer',
        loading: 'Even laden…',
        optional: 'optioneel',
        yes: 'Ja',
        no: 'Nee',
        none: 'Geen',
        everyone: 'Iedereen',
        minutes: { one: '{count} minuut', other: '{count} minuten' },
        minutesShort: '{count} min',
        hoursMinutes: '{h} uur {m} min',
        hours: { one: '{count} uur', other: '{count} uur' },
        points: { one: '{count} punt', other: '{count} punten' },
        by: 'door {name}',
        unknown: 'Onbekend',
        errorLoad: 'Dit lukte even niet. Probeer het opnieuw.',
        savedOk: 'Opgeslagen',
    },
    offline: 'Geen verbinding met de server. We proberen het vanzelf opnieuw.',
    // ---- W1 Vandaag ----------------------------------------------------------------------------
    today: {
        goodMorning: 'Goedemorgen',
        goodAfternoon: 'Goedemiddag',
        goodEvening: 'Goedenavond',
        goodNight: 'Goedenacht',
        week: 'Week {week}',
        next: 'Straks',
        now: 'Nu bezig',
        startsIn: 'over {time}',
        endsIn: 'nog {time}',
        nothingNext: 'Niets meer gepland vandaag',
        nothingNextBody: 'Tijd voor elkaar.',
        agenda: 'Agenda vandaag',
        addEvent: 'Afspraak',
        addEventLong: 'Afspraak toevoegen',
        tasks: 'Taken vandaag',
        tasksAll: 'Alle taken',
        noTasks: 'Geen taken vandaag',
        approvals: 'Goedkeuren',
        approvalsWaiting: {
            one: '{count} ding wacht op jou',
            other: '{count} dingen wachten op jou',
        },
        approvalsView: 'Bekijken',
        ridesOpen: {
            one: '{count} rit zonder rijder',
            other: '{count} ritten zonder rijder',
        },
        ridesAll: 'Alle ritten',
        tomorrow: 'Morgen',
        tomorrowNothing: 'Morgen staat er nog niets.',
        toAgenda: 'Naar de agenda',
        goalsTitle: 'Sparen',
    },
    // ---- W2 Agenda -----------------------------------------------------------------------------
    agenda: {
        title: 'Agenda',
        prev: 'Vorige',
        next: 'Volgende',
        today: 'Vandaag',
        newEvent: 'Afspraak',
        filter: 'Laat zien voor',
        filterAll: 'Iedereen',
        emptyDay: 'Nog niets gepland op deze dag',
        emptyDayBody: 'Tik op + om iets toe te voegen.',
        emptyWeek: 'Nog niets gepland deze week',
        emptyRange: 'Nog niets gepland',
        weekTitle: 'Week {week} · {range}',
        trash: 'Prullenbak',
        trashIntro: 'Verwijderde afspraken blijven 30 dagen bewaard.',
        trashEmpty: 'De prullenbak is leeg.',
        restore: 'Terugzetten',
        restoreUntil: 'Terug te zetten tot {date}',
        restored: '{title} staat weer in de agenda',
        restoreExpired: 'Deze afspraak is al langer dan 30 dagen weg en kan niet meer terug.',
        export: 'Agenda exporteren',
        exportIntro: 'Download de agenda als .ics-bestand voor je telefoon of computer.',
        exportHousehold: 'Hele gezin',
        moved: '{title} verplaatst naar {when}',
        moveFailed: 'Verplaatsen lukte niet. De afspraak staat weer op zijn plek.',
        dragHint: 'Sleep een afspraak om hem te verplaatsen.',
        allDay: 'Hele dag',
        moreItems: '+{count} meer',
    },
    // ---- Detail van één afspraak (sheet) ------------------------------------------------------
    event: {
        when: 'Wanneer',
        leave: 'Vertrekken',
        who: 'Wie',
        where: 'Waar',
        notes: 'Notitie',
        repeats: 'Herhaling',
        rides: 'Brengen en halen',
        dropoff: 'Brengen',
        pickup: 'Halen',
        driverOpen: 'Wie rijdt?',
        driverIs: '{name} rijdt',
        iDrive: 'Ik rijd',
        chooseDriver: 'Kies wie rijdt',
        nobody: 'Nog niemand',
        driverSaved: '{name} rijdt',
        driverCleared: 'Rijder weggehaald',
        depart: 'Vertrek {time}',
        travel: '{count} min reistijd',
        edit: 'Bewerken',
        cancelOne: 'Deze keer afgelasten',
        cancelledOne: '{title} gaat deze keer niet door',
        cancelled: 'Afgelast',
        restoreOne: 'Toch laten doorgaan',
        restoredOne: '{title} gaat toch door',
        // Zet deze keer terug naar de reeks (tijd, plek …). Een overgenomen rit en een overgeslagen
        // herinnering blijven staan (eigen knoppen: "Terug naar normaal", "Toch roepen"); de melding
        // zegt dat (DESIGN.md §8.W4a).
        resetOne: 'Terug naar de gewone afspraak',
        resetDone: 'Deze keer staat weer zoals de reeks',
        resetKeptRide: 'Deze keer staat weer zoals de reeks. Wie er rijdt, blijft zoals je het voor deze keer regelde.',
        resetKeptReminder: 'Deze keer staat weer zoals de reeks. De overgeslagen herinnering blijft deze keer stil.',
        resetKeptBoth: 'Deze keer staat weer zoals de reeks. Wie er rijdt en de overgeslagen herinnering blijven zoals je ze voor deze keer regelde.',
        moved: 'Verplaatst',
        changed: 'Gewijzigd',
        delete: 'Verwijderen',
        deleted: '{title} verwijderd',
        deleteTitle: '{title} verwijderen?',
        deleteBody: 'Je kunt hem 30 dagen terugzetten uit de prullenbak.',
        duplicate: 'Dupliceren',
        duplicated: 'Kopie gemaakt',
        history: 'Wat is er veranderd?',
        historyEmpty: 'Nog geen wijzigingen.',
        historyItem: '{who} · {when}',
        conflict: 'Tegelijk met iets anders',
        conflictWith: {
            one: '{names} heeft dan ook {title}',
            other: '{names} hebben dan ook {title}',
        },
        conflictDrive: '{name} rijdt om {time} en heeft dan nog {title}',
        lastChanged: 'Laatst gewijzigd door {name}',
        notFound: 'Deze afspraak bestaat niet meer.',
        action: {
            create: 'aangemaakt',
            update: 'gewijzigd',
            delete: 'verwijderd',
            restore: 'teruggezet',
            split: 'vanaf hier gewijzigd',
            cancel: 'afgelast',
            uncancel: 'gaat toch door',
            move: 'verplaatst',
            override: 'deze keer aangepast',
            override_clear: 'terug naar de reeks',
            role: 'rijder gewijzigd',
        },
    },
    // ---- W3 Afspraak-editor --------------------------------------------------------------------
    editor: {
        newTitle: 'Nieuwe afspraak',
        editTitle: 'Afspraak bewerken',
        title: 'Wat',
        titlePlaceholder: 'Bijvoorbeeld Zwemles',
        titleHint: 'Kort en duidelijk, bijvoorbeeld Zwemles',
        templates: 'Snel kiezen',
        picto: 'Pictogram',
        pictoChoose: 'Kies een pictogram',
        pictoChange: 'Ander pictogram',
        who: 'Voor wie',
        everyone: 'Iedereen',
        date: 'Datum',
        allDay: 'Hele dag',
        start: 'Van',
        end: 'Tot',
        duration: 'Duur',
        endDate: 'Tot en met',
        endBeforeStart: 'De eindtijd ligt voor de begintijd.',
        repeat: 'Herhalen',
        repeatNone: 'Niet',
        repeatDaily: 'Elke dag',
        repeatWeekly: 'Elke week',
        repeatBiweekly: 'Om de week',
        repeatMonthly: 'Elke maand',
        repeatYearly: 'Elk jaar',
        onDays: 'Op welke dagen',
        monthlyHow: 'Welke dag van de maand',
        monthlyDay: 'Op de {day}e',
        monthlyLast: 'Op de laatste dag',
        monthlyNth: 'Op de {ordinal} {weekday}',
        ordinal: {
            '1': 'eerste',
            '2': 'tweede',
            '3': 'derde',
            '4': 'vierde',
            '-1': 'laatste',
        },
        parity: 'Welke weken',
        parityAll: 'Alle weken',
        parityEven: 'Even weken',
        parityOdd: 'Oneven weken',
        ends: 'Stopt',
        endsNever: 'Nooit',
        endsCount: 'Na een aantal keer',
        endsUntil: 'Op een datum',
        count: 'Aantal keer',
        until: 'Tot en met',
        nextDates: 'Eerstvolgende keren',
        rides: 'Brengen en halen',
        ridesHint: 'Wie brengt en wie haalt? Kies "Nog niet bekend" als je het nog niet weet.',
        dropoff: 'Brengen',
        pickup: 'Halen',
        roleNone: 'Niet nodig',
        roleOpen: 'Nog open (wie rijdt?)',
        travel: 'Reistijd',
        travelNone: 'Geen',
        travelOwn: 'Eigen tijd…',
        travelOwnLabel: 'Reistijd in minuten',
        /** 0056: dezelfde reistijd ook ná de afspraak. */
        travelBack: 'Reistijd terug',
        travelBackHint: 'Dezelfde reistijd ook na de afspraak, voor de weg naar huis.',
        travelAuto: 'Automatisch (via de plek)',
        travelAutoWith: 'Automatisch ({minutes} min)',
        departureAlert: 'Seintje om te vertrekken',
        departureAlertHint: 'Het bord laat zien wanneer je moet vertrekken.',
        departureNone: 'Geen seintje',
        departureBefore: '{count} min vooraf',
        location: 'Waar',
        locationPlaceholder: 'Bijvoorbeeld Sportfondsenbad',
        notes: 'Notitie',
        notesPlaceholder: 'Zwemtas en handdoek mee',
        category: 'Soort',
        // Release-c r2: zeg wat erachter zit, zodat "Brengen en halen" te vinden is.
        more: 'Meer opties: brengen en halen, waar, notitie',
        less: 'Minder opties',
        /** Golf 2 (oprichter #11): de editor uitklappen tot volledig scherm en terug. */
        fullScreen: 'Volledig scherm',
        smallScreen: 'Kleiner maken',
        /** Ronde 1: Escape of Sluiten in het volledige scherm met ingevulde tekst. */
        discardTitle: 'Wijzigingen weggooien?',
        discardBody: 'Wat je hebt ingevuld, is dan weg.',
        discardKeep: 'Verder bewerken',
        discardConfirm: 'Weggooien',
        create: 'Afspraak opslaan',
        save: 'Opslaan',
        created: '{title} staat in de agenda',
        saved: 'Afspraak opgeslagen',
        conflictNotice: {
            one: '{names} heeft dan ook {title} ({time}).',
            other: '{names} hebben dan ook {title} ({time}).',
        },
        orphansTitle: 'Er zijn losse aanpassingen',
        orphansBody: 'Sommige keren had je apart aangepast en die vallen nu weg. Wat wil je daarmee doen?',
        orphansKeep: 'Bewaren als losse afspraken',
        orphansDelete: 'Weggooien',
        onlyThisNoRepeat: 'Een herhaling wijzig je voor deze en volgende keren of de hele reeks.',
        titleRequired: 'Vul in wat het is.',
        memberRequired: 'Kies voor wie het is.',
        categories: {
            sport: 'Sport',
            school: 'School',
            medisch: 'Dokter en tandarts',
            sociaal: 'Afspraak',
            werk: 'Werk',
            verjaardag: 'Verjaardag',
            overig: 'Overig',
        },
    },
    // ---- Bereikvraag (aanvulling op design.scope) --------------------------------------------
    scope: {
        thisHint: 'Alleen {date}',
        followingHint: 'Vanaf {date}',
        allHint: 'Alle keren, ook eerder',
        deleteFollowing: 'Deze en volgende verwijderen',
        confirm: 'Doorgaan',
    },
    // ---- W4 Ritten ------------------------------------------------------------------------------
    rides: {
        title: 'Ritten',
        subtitle: 'Wie brengt en haalt wie, de komende week.',
        open: 'Nog geen rijder',
        arranged: 'Geregeld',
        empty: 'Alle ritten zijn geregeld.',
        emptyBody: 'Niemand hoeft te zoeken naar een lift.',
        none: 'Geen ritten deze week.',
        noneBody: 'Zet bij een afspraak wie brengt of haalt, dan verschijnt die hier.',
        iDrive: 'Ik rijd',
        choose: 'Kies',
        dropoff: 'Brengen',
        pickup: 'Halen',
        notLinked: 'Je login is nog niet aan een gezinslid gekoppeld. Kies hieronder wie rijdt.',
    },
    // ---- W5 Taken ------------------------------------------------------------------------------
    tasks: {
        title: 'Taken',
        viewToday: 'Vandaag',
        viewWeek: 'Week',
        viewAll: 'Alle',
        add: 'Taak',
        addLong: 'Taak toevoegen',
        newTitle: 'Nieuwe taak',
        editTitle: 'Taak bewerken',
        library: 'Klusjes-ideeën',
        libraryIntro: 'Kies een klusje en voor wie het is. Punten passen bij de leeftijd.',
        libraryAdd: 'Toevoegen',
        libraryFor: 'Voor wie',
        what: 'Wat',
        titlePlaceholder: 'Bijvoorbeeld Tafel dekken',
        who: 'Voor wie',
        mode: 'Hoe',
        modeEach: 'Ieder apart',
        modeEachHint: 'Iedereen doet het zelf en krijgt eigen punten.',
        modeTogether: 'Samen',
        modeTogetherHint: 'Jullie doen het samen; één vinkje voor iedereen.',
        modeFirst: 'Wie het eerst',
        modeFirstHint: 'Wie het als eerste doet, krijgt de punten.',
        repeat: 'Hoe vaak',
        repeatOnce: 'Eén keer',
        repeatDaily: 'Elke dag',
        repeatWeekdays: 'Op werkdagen',
        repeatWeekly: 'Elke week',
        repeatMonthly: 'Elke maand',
        onDays: 'Op welke dagen',
        monthDay: 'Op dag',
        monthLast: 'Laatste dag',
        startDate: 'Vanaf',
        date: 'Op',
        dueDate: 'Uiterlijk',
        timeOfDay: 'Wanneer op de dag',
        tod: {
            any: 'Hele dag',
            morning: 'Ochtend',
            afternoon: 'Middag',
            evening: 'Avond',
        },
        dueTime: 'Klaar om',
        points: 'Punten',
        pointsHint: 'Hoeveel sterren levert het op? 0 mag ook.',
        approval: 'Goedkeuring nodig',
        approvalHint: 'Papa of mama keurt de taak goed voordat de punten tellen.',
        /** Golf 6b fixer r2: met Beloningen uit (geen punten). */
        approvalHintNoPoints: 'Papa of mama kijkt de taak na voordat hij als klaar telt.',
        description: 'Uitleg',
        create: 'Taak opslaan',
        created: '{title} staat klaar',
        saved: 'Taak opgeslagen',
        deleteTitle: '{title} verwijderen?',
        deleted: '{title} verwijderd',
        duplicateTitle: 'Deze taak bestaat al',
        duplicateBody: 'Er is al een taak {title} voor {names}. Toch nog een toevoegen?',
        addAnyway: 'Toch toevoegen',
        emptyTitle: 'Nog geen taken',
        emptyBody: 'Begin met iets kleins, zoals tanden poetsen.',
        emptyToday: 'Geen taken vandaag',
        emptyTodayBody: 'Taken voor vandaag verschijnen hier.',
        progress: '{done} van {total} klaar',
        completeFor: 'Afvinken voor {name}',
        completed: '{title} afgevinkt',
        revert: 'Terugzetten naar open',
        reverted: '{title} staat weer open',
        skip: 'Overslaan',
        skipped: '{title} overgeslagen',
        unskip: 'Toch doen',
        state: {
            open: 'Open',
            done: 'Klaar',
            pending: 'Wacht op goedkeuring',
            rejected: 'Nog een keer',
            skipped: 'Overgeslagen',
            missed: 'Gemist',
        },
        late: 'Nog van gisteren',
        next: 'Volgende keer: {date}',
        noNext: 'Geen volgende keer',
        together: 'Samen',
        negativeTitle: 'Punten gaan onder nul',
        negativeBody: '{names} heeft deze punten al uitgegeven. Het saldo wordt dan negatief.',
        negativeConfirm: 'Toch terugzetten',
        perMember: 'Punten per kind',
    },
    // ---- W6 Beloningen -------------------------------------------------------------------------
    rewards: {
        title: 'Beloningen',
        savings: 'Spaarpotten',
        available: '{count} te besteden',
        reserved: '{count} gereserveerd',
        goal: 'Spaart voor',
        noGoal: 'Nog geen spaardoel',
        setGoal: 'Spaardoel',
        goalNone: 'Geen doel',
        chooseGoal: 'Kies een spaardoel',
        ledger: {
            task_credit: 'Taak',
            task_reversal: 'Taak teruggezet',
            reward_debit: 'Beloning',
            reward_refund: 'Beloning terug',
            manual_adjustment: 'Aangepast door een ouder',
            bonus: 'Bonus',
            // Sprint 4 (kamers): punten voor schoonmaak.
            cleaning_credit: 'Schoonmaak',
            cleaning_reversal: 'Schoonmaak teruggezet',
            // Golf 7 (0048): neutraal (blijft staan na wissen).
            learning_credit: 'Goed geleerd',
            learning_reversal: 'Goed geleerd teruggezet',
        },
        goalMissing: {
            one: 'Nog {count} punt',
            other: 'Nog {count} punten',
        },
        goalReached: 'Genoeg gespaard',
        goalSaved: 'Spaardoel opgeslagen',
        catalogue: 'Om voor te sparen',
        add: 'Beloning',
        addLong: 'Beloning toevoegen',
        newTitle: 'Nieuwe beloning',
        editTitle: 'Beloning bewerken',
        name: 'Wat',
        namePlaceholder: 'Bijvoorbeeld Samen een ijsje halen',
        cost: 'Hoeveel sterren?',
        costHint: 'Zoveel sterren kost de beloning (1 tot 9999).',
        costInvalid: 'Kies een getal van 1 tot 9999.',
        forWhom: 'Voor wie',
        forAll: 'Iedereen met punten',
        limit: 'Hoe vaak',
        limitNone: 'Zo vaak als je wilt',
        limitDay: '{count}× per dag',
        limitWeek: '{count}× per week',
        limitMonth: '{count}× per maand',
        stock: 'Voorraad',
        stockNone: 'Onbeperkt',
        stockLeft: 'Nog {count} over',
        created: '{name} toegevoegd',
        saved: 'Beloning opgeslagen',
        archive: 'Weghalen',
        archiveTitle: '{name} weghalen?',
        archiveBody: 'Kinderen zien hem daarna niet meer. Eerdere aanvragen blijven bewaard.',
        archived: '{name} weggehaald',
        requests: 'Aanvragen',
        requestsEmpty: 'Geen openstaande aanvragen.',
        give: 'Geven',
        given: '{name} gegeven aan {member}',
        decline: 'Afwijzen',
        declined: 'Aanvraag afgewezen; de punten zijn terug',
        adjust: 'Punten aanpassen',
        adjustTitle: 'Punten aanpassen voor {name}',
        adjustAmount: 'Hoeveel',
        adjustAmountHint: 'Gebruik een min voor aftrekken, bijvoorbeeld -5.',
        adjustReason: 'Waarom',
        adjustReasonPlaceholder: 'Bijvoorbeeld Extra hulp in de tuin',
        adjustInvalid: 'Kies een getal tussen -999 en 999 (niet 0).',
        adjustReasonRequired: 'Schrijf kort waarom.',
        adjusted: 'Saldo van {name} is nu {count}',
        negativeTitle: 'Saldo wordt negatief',
        negativeBody: 'Hierdoor komt {name} onder nul. Weet je het zeker?',
        negativeConfirm: 'Ja, aanpassen',
        history: 'Laatste punten',
        historyEmpty: 'Nog geen punten verdiend.',
        pointsOff: 'Punten staan uit',
        export: 'Exporteren (CSV)',
    },
    // ---- W7 Goedkeuren -------------------------------------------------------------------------
    approvals: {
        title: 'Goedkeuren',
        open: 'Open',
        handled: 'Afgehandeld',
        approve: 'Goedkeuren',
        approved: '{title} goedgekeurd',
        reject: 'Afwijzen',
        rejectTitle: '{title} afwijzen?',
        rejectNote: 'Wat moet er nog gebeuren?',
        rejectNotePlaceholder: 'Bijvoorbeeld De borden moeten nog op tafel',
        rejected: '{title} gaat terug naar {name}',
        asks: '{name} vraagt',
        doneAt: 'klaar om {time}',
        doneAgo: 'klaar {ago}',
        give: 'Geven',
        decline: 'Afwijzen',
        notices: 'Goed om te weten',
        emptyTitle: 'Alles afgehandeld',
        emptyBody: 'Niets om goed te keuren.',
        handledEmpty: 'Hier komt te staan wat je hebt afgehandeld.',
        state: {
            fulfilled: 'Gegeven',
            declined: 'Afgewezen',
            cancelled: 'Ingetrokken',
            expired: 'Verlopen',
            pending: 'Open',
        },
        together: 'samen met {names}',
    },
    // ---- W8 Leden ------------------------------------------------------------------------------
    members: {
        title: 'Gezin',
        intro: 'Iedereen die op het bord staat. Kleur en gezichtje zie je overal terug.',
        add: 'Gezinslid',
        addLong: 'Gezinslid toevoegen',
        newTitle: 'Nieuw gezinslid',
        editTitle: '{name} bewerken',
        // Volgorde van het gezin (2026-10-01).
        orderHint: 'Met de pijltjes zet je de volgorde. Die geldt overal: in de app en op het bord.',
        moveUp: '{name} eerder zetten',
        moveDown: '{name} later zetten',
        orderNow: '{name} staat nu op plaats {position} van {count}.',
        orderStale: 'Er is intussen iets veranderd in het gezin. De lijst is opnieuw geladen.',
        name: 'Naam',
        namePlaceholder: 'Bijvoorbeeld Sem',
        // 0057 (oprichter 1 okt): initialen achter de afspraak.
        initials: 'Initialen',
        initialsHint: 'Eén tot drie letters. Ze staan in de agenda achter de afspraak, bijvoorbeeld Sohbet · A.',
        initialsInvalid: 'Vul één tot drie letters in.',
        kind: 'Wie is het',
        kindAdult: 'Ouder',
        kindChild: 'Kind',
        kindHelper: 'Oppas of helper',
        age: 'Leeftijd',
        ageNone: 'Weet ik niet',
        ageBands: {
            '0-5': 'tot 6 jaar',
            '6-9': '6–9 jaar',
            '10-12': '10–12 jaar',
            '13-15': '13–15 jaar',
            '16+': '16 jaar of ouder',
        },
        face: 'Gezichtje',
        faceNone: 'Eerste letter',
        preview: 'Zo ziet het eruit',
        saved: '{name} opgeslagen',
        created: '{name} hoort er nu bij',
        you: 'Jij',
        points: 'Spaart punten',
        inviteTitle: 'Nodig je partner uit',
        inviteBody: 'Samen plannen gaat makkelijker. Voeg je partner toe en nodig die daarna per e-mail uit.',
    },
    // ---- W9 Apparaten ---------------------------------------------------------------------------
    devices: {
        title: 'Tablets',
        intro: 'De tablets waarop het gezinsbord draait.',
        add: 'Tablet koppelen',
        online: 'Online',
        seen: 'Laatst gezien {ago}',
        never: 'Nog nooit gezien',
        version: 'Versie {version}',
        room: 'Kamer',
        rename: 'Wijzigen',
        renameTitle: 'Tablet wijzigen',
        /** Golf 4 (DESIGN §8.K16): weergave van het bord per tablet. */
        layout: 'Weergave',
        layoutAuto: 'Automatisch',
        layoutAutoHint: 'Past zich vanzelf aan het scherm aan, ook als je de tablet draait: compact op een klein scherm, breed op een groot scherm dat liggend hangt, anders groot.',
        layoutLarge: 'Groot',
        layoutLargeHint: 'Het hele bord naast elkaar, zoals op de iPad in de woonkamer.',
        layoutCompact: 'Compact',
        layoutCompactHint: 'Minder naast elkaar en alles groter, leesbaar op 2 meter. Voor een kleine tablet of een iPad mini.',
        layoutShown: 'Weergave: {layout}',
        /** Tablet-breed (docs/onderzoek/tablet-breed.md §5): breed (en automatisch op elk scherm). */
        layoutWide: 'Breed',
        layoutWideHint: 'Agenda, taken en een kolom Vandaag naast elkaar. Voor een tablet van 10 inch of groter die liggend hangt.',
        revoke: 'Loskoppelen',
        revokeTitle: 'Deze tablet loskoppelen?',
        revokeBody: '{name} toont daarna weer een koppelcode. Je kunt hem later opnieuw koppelen.',
        revoked: '{name} losgekoppeld',
        saved: 'Tablet opgeslagen',
        statusRevoked: 'Losgekoppeld',
        statusSuspect: 'Controleren',
        emptyTitle: 'Koppel de tablet',
        emptyBody: 'Open het gezinsbord op de tablet en vul de code hier in.',
    },
    // ---- W10 Instellingen -----------------------------------------------------------------------
    settings: {
        title: 'Instellingen',
        household: 'Huishouden',
        householdName: 'Naam',
        timezone: 'Tijdzone',
        wizard: 'Huishouden instellen',
        security: 'Beveiliging',
        securityBody: 'Vertrouwde netwerken, browsers en sessies.',
        export: 'Agenda exporteren',
        exportBody: 'Download de agenda als .ics-bestand, voor het hele gezin of per persoon.',
        exportAll: 'Hele gezin',
        /** Gegevensexport (AVG art. 15 en 20; review d-fs r2). Altijd eerst het wachtwoord. */
        data: 'Gegevens downloaden',
        dataBody: 'Een kopie van jullie gegevens als bestand (JSON), ook de keuzes bij Wat past bij ons gezin. Je bevestigt eerst met je wachtwoord.',
        dataMine: 'Mijn gegevens',
        dataAll: 'Hele gezin',
        dataStarted: 'Het bestand staat in je downloads.',
        about: 'Over',
        version: 'Versie {version}',
        open: 'Openen',
    },
    // ---- W11 Wizard -----------------------------------------------------------------------------
    wizard: {
        step: 'Stap {n} van {total}',
        step1Title: 'Welkom thuis',
        step1Body: 'Samen de week overzien, zonder gedoe. We beginnen met je gezin.',
        householdName: 'Naam van je huishouden',
        householdPlaceholder: 'Familie de Vries',
        yourName: 'Jouw naam op het bord',
        yourNameHint: 'Bijvoorbeeld Papa of Sanne',
        step2Title: 'Wie horen erbij?',
        step2Body: 'Geef iedereen een kleur. Een kind kan ook een dier kiezen.',
        addMember: 'Nog iemand toevoegen',
        memberAdded: '{name} toegevoegd',
        step3Title: 'Eerste taken',
        step3Body: 'Tik een paar vaste klusjes aan. Je kunt later alles aanpassen.',
        step3For: 'Voor de kinderen',
        step3Added: {
            one: '{count} taak toegevoegd',
            other: '{count} taken toegevoegd',
        },
        step3NoKids: 'Voeg eerst een kind toe om taken te geven.',
        step4Title: 'Koppel de tablet',
        step4Body: 'Open het gezinsbord op de tablet in de woonkamer en vul de code in.',
        pairNow: 'Tablet koppelen',
        finish: 'Klaar',
        done: 'Je huishouden staat klaar',
    },
    // ---- Fout- en lege staten ------------------------------------------------------------------
    notFoundTitle: 'Deze pagina bestaat niet',
    notFoundBody: 'Misschien is de link oud. Ga terug naar vandaag.',
    toToday: 'Naar Vandaag',
    crashTitle: 'Oeps, dat ging mis',
    crashBody: 'Probeer het nog een keer. Lukt het niet? Laad de pagina opnieuw.',
    reload: 'Opnieuw laden',
};
//# sourceMappingURL=app.nl.js.map